import React, { useState, useRef, useEffect } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";

export default function DetailsNavbar() {
  const navigate = useNavigate();
  const isCustomerDashboard =
    window.location.pathname === "/Customer-Dashboard";

     const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
      const headerRef = useRef(null);
    
      const toggleMenu = () => {
        setIsMenuOpen((prev) => !prev);
      };
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

      // Close menu when clicking outside header
      useEffect(() => {
        const handleClickOutside = (event) => {
          if (
            headerRef.current &&
            !headerRef.current.contains(event.target)
          ) {
            setIsMenuOpen(false);
          }
        };
    
        document.addEventListener("click", handleClickOutside);
        return () => document.removeEventListener("click", handleClickOutside);
      }, []);
    
  return (
    <React.Fragment>
      <header ref={headerRef}>
        <section
          className="nav-section static-navbar"
          style={{
            background: "transparent",
            padding: "0rem 1rem",
          }}
        >
          <nav className="main-navbar">
            <NavLink to='/'  className="logo" style={{ background: "transparent" , cursor:"pointer"}}>
              <img
                src="/assets/images/credence-pay-logo.png"
                alt="Credence Resource Management, LLC logo"
                width="auto"
              />
            </NavLink>
            <button className="main-menu-toggle" aria-label="Toggle navigation menu" aria-expanded="false" aria-controls="main-navigation" onClick={toggleMenu}>☰</button>
            <ul className={`main-nav-links ${isMenuOpen ? "active" : ""}`}>
              <li>
                <NavLink to="/">Home</NavLink>
              </li>
              <li>
                <NavLink to="/About-Us">
                  About Us
                </NavLink>
              </li>
              {/* <li>
                <NavLink to="/FAQ">FAQ's</NavLink>
              </li> */}
              <li>
                <NavLink to="/Privacy-Policy">
                  Privacy
                </NavLink>
              </li>
              <li>
                <NavLink to="/Contact-Us">Contact</NavLink>
              </li>
            </ul>
          </nav>
        </section>
      </header>
    </React.Fragment>
  );
}
